import $ from 'jquery';

// Response is initially hidden (spacing purposes).
// Show response container when notice can be shown.
$(document).on('ready', () => {
  if ($('.wpcf7').length) {
    const showResponseDiv = () =>
      $('.hide-response').removeClass('hide-response');

    document.addEventListener('wpcf7submit', () => showResponseDiv());
    document.addEventListener('wpcf7invalid', () => showResponseDiv());

    if ($('.form__select--hide-first').length) {
      $('.form__select--hide-first .wpcf7-select')
        .children('option')
        .first()
        .prop('selected', 'selected')
        .prop('disabled', 'disabled');
    }
  }
});
